import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
import ChevronRight from '@interco/icons/core/action-navigation/ic_chevron_right'
import { trackingRefin } from '@store/refinanciamento/simulacao/actions'
import routes from '@routes/routes'
import {
  ConveniosCodes,
  DOCUMENTOS_IDENTIFICACAO,
  StepRefin,
  TipoDocumento,
  TipoDocumentoIdentificacao,
} from '@utils/enums'
import { setTipoDocumento } from '@store/refinanciamento/documentos/actions'
import { ColorWrapper, TextParagraph } from '@atoms'
import { Colors } from '@utils/Colors'
import { BridgeService } from '@services/bridge'
import { ApplicationState } from '@store/types'

import { Bolder, ColumnText, LineInfo } from '../../styles'
import { sendAppDocumentTag, sendWebDocumentTag } from '../tracking'

interface Props {
  setOpenTipoDoc: React.Dispatch<React.SetStateAction<boolean>>
}

const trackingStepByTipoDoc: Record<TipoDocumentoIdentificacao, StepRefin> = {
  [TipoDocumento.CNH]: StepRefin.CLICK_TIPO_DOCUMENTO_CNH,
  [TipoDocumento.RG]: StepRefin.CLICK_TIPO_DOCUMENTO_RG,
  [TipoDocumento.CIN]: StepRefin.CLICK_TIPO_DOCUMENTO_CIN,
  [TipoDocumento.DNI]: StepRefin.CLICK_TIPO_DOCUMENTO_DNI,
  [TipoDocumento.RNE]: StepRefin.CLICK_TIPO_DOCUMENTO_RNE,
  [TipoDocumento.RNM]: StepRefin.CLICK_TIPO_DOCUMENTO_RNM,
  [TipoDocumento.CARTEIRA_FUNCIONAL]: StepRefin.CLICK_TIPO_DOCUMENTO_CARTEIRA_FUNCIONAL,
}

const BottomsheetTipoDoc = ({ setOpenTipoDoc }: Props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { convenioCodigo } = useSelector(
    (state: ApplicationState) => state.refinanciamento.contratos,
  )
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  useEffect(() => {
    BridgeService.tac({
      name: 'bottomsheet_tipo_doc',
      actions: ['abrir_bottomsheet_tipo_doc'],
    })

    if (isApp) {
      sendAppDocumentTag()
    } else {
      sendWebDocumentTag()
    }
  }, [isApp])

  const handleClose = () => {
    BridgeService.tic({
      name: 'btn_fechar_tipo_doc',
      action: 'fechar_bottomsheet_tipo_doc',
    })

    if (isApp) {
      sendAppDocumentTag({ ref_type: 'botao', content_action: 'Toque' })
    } else {
      sendWebDocumentTag({ element_action: 'click button' })
    }

    setOpenTipoDoc(false)
  }

  const selectNavigate = (tipoDoc: TipoDocumentoIdentificacao) => {
    dispatch(trackingRefin(trackingStepByTipoDoc[tipoDoc] ?? StepRefin.CLICK_TIPO_DOCUMENTO_RG))
    dispatch(trackingRefin(StepRefin.INICIO_CAPTURA_DOCUMENTOS))
    dispatch(setTipoDocumento(tipoDoc))

    BridgeService.tic({
      name: 'btn_iniciar_foto_documento',
      action: 'solicitar_documento_id',
    })

    if (isApp) {
      sendAppDocumentTag({ ref_type: 'botao', content_action: 'Toque' })
    } else {
      sendWebDocumentTag({
        element_action: 'click button',
        redirect_url: routes.MODO_ENVIO,
      })
    }

    navigate(routes.MODO_ENVIO)
  }

  const documentosDisponiveis = DOCUMENTOS_IDENTIFICACAO.filter(
    ({ value }) =>
      value !== TipoDocumento.CARTEIRA_FUNCIONAL ||
      convenioCodigo === ConveniosCodes.INSS ||
      convenioCodigo === ConveniosCodes.SIAPE_SERVIDOR_FEDERAL,
  )

  return (
    <BottomSheet onClose={handleClose}>
      <ColorWrapper color={Colors.GRAY500} fontWeight="600" margin="22px 0 16px 0">
        <TextParagraph variant="headline-h3">Qual documento você quer enviar?</TextParagraph>
      </ColorWrapper>
      {documentosDisponiveis.map((documentType, index) => (
        <LineInfo
          key={documentType.value}
          onClick={() => selectNavigate(documentType.value)}
          removeBorder={index === documentosDisponiveis.length - 1}
        >
          <ColumnText>
            <ColorWrapper color={Colors.GRAY500} margin="0">
              <TextParagraph variant="body-3">
                <Bolder>{documentType.name}</Bolder>
              </TextParagraph>
            </ColorWrapper>
          </ColumnText>
          <ChevronRight height={24} width={24} color={Colors.PRIMARY500} />
        </LineInfo>
      ))}
    </BottomSheet>
  )
}
export default BottomsheetTipoDoc
